import { Injectable } from '@angular/core';
import {HttpClient, HttpHeaders} from "@angular/common/http";
import {environment} from "../../environments/environment";
import {Constants} from "../../constants";

@Injectable({
  providedIn: 'root'
})
export class OrderAddressService {

  constructor(private http: HttpClient) {}

  getPublicRequestHeaders() {
    return new HttpHeaders({
      'Content-Type': 'application/json',
      'Accept': 'application/json',
      'Authorization': environment.publicApiToken,
    });
  }

  getRequestHeaders() {
    return new HttpHeaders({
      'Content-Type': 'application/json',
      'Accept': 'application/json',
      'Authorization': localStorage.getItem(Constants.LOCAL_TOKEN) ?? environment.publicApiToken
    });
  }

  get(params: any) {
    return this.http.get(environment.apiUrl + '/orderAddresses', {params: params, headers: this.getRequestHeaders()});
  }

  getById(id: string) {
    return this.http.get(environment.apiUrl + '/orderAddresses/' + id, {headers: this.getRequestHeaders()});
  }

  create(order: any) {
    return this.http.post(environment.publicApiUrl + '/orderAddresses', order, {headers: this.getPublicRequestHeaders()});
  }

  update(id: string, order: any) {
    return this.http.put(environment.publicApiUrl + '/orderAddresses/' + id, order, {headers: this.getPublicRequestHeaders()});
  }

  delete(id: string) {
    return this.http.delete(environment.apiUrl + '/orderAddresses/' + id, {headers: this.getRequestHeaders()});
  }

}
